import { projectSlice } from '../projectSlice';
import { updateConnectionThunk } from './AsyncConnectionUpdate';

export const SetSectionValue = (valveConnectionKey: string, id: string, name: string, value: any) => {
  return async (dispatch: any, getState: any) => {
    await dispatch(projectSlice.actions.updateSection({ id: id, name: name, value: value }));
    await dispatch(updateConnectionThunk(valveConnectionKey));
  };
};
